import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const FREELANCER_GET_ARTICLES_REQUEST = "FREELANCER_GET_USERS_REQUEST";
export const FREELANCER_GET_ARTICLES_SUCCESS =
  "FREELANCER_GET_ARTICLES_SUCCESS";
export const FREELANCER_GET_ARTICLES_FAIL = "FREELANCER_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: FREELANCER_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "dashboard/freelancer_posts",
      params: params,
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FREELANCER_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FREELANCER_GET_CATEGORIES_REQUEST =
  "FREELANCER_GET_CATEGORIES_REQUEST";
export const FREELANCER_GET_CATEGORIES_SUCCESS =
  "FREELANCER_GET_CATEGORIES_SUCCESS";
export const FREELANCER_GET_CATEGORIES_FAIL = "FREELANCER_GET_CATEGORIES_FAIL";
export const getCategories = params => dispatch => {
  dispatch({
    type: FREELANCER_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "categories",
      params: {
        post_type: "freelancer_post"
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FREELANCER_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FREELANCER_REMOVE_ARTICLE_REQUEST =
  "FREELANCER_REMOVE_ARTICLE_REQUEST";
export const FREELANCER_REMOVE_ARTICLE_SUCCESS =
  "FREELANCER_REMOVE_ARTICLE_SUCCESS";
export const FREELANCER_REMOVE_ARTICLE_FAIL = "FREELANCER_REMOVE_ARTICLE_FAIL";
export const removeArticle = ({ post_id, path }) => dispatch => {
  dispatch({
    type: FREELANCER_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post/remove",
      data: {
        post_id
      },
      method: "post"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        if (path === "user") {
          dispatch(push("/dash/user/management/articles"));
        } else {
          dispatch(push("/dash/admin/other-articles"));
        }
      } else {
        dispatch({
          type: FREELANCER_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};

export const FREELANCER_GET_ARTICLE_REQUEST = "FREELANCER_GET_ARTICLE_REQUEST";
export const FREELANCER_GET_ARTICLE_SUCCESS = "FREELANCER_GET_ARTICLE_SUCCESS";
export const FREELANCER_GET_ARTICLE_FAIL = "FREELANCER_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: FREELANCER_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/post",
      params: {
        post_id: id
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: FREELANCER_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FREELANCER_EDIT_ARTICLE_REQUEST =
  "FREELANCER_EDIT_ARTICLE_REQUEST";
export const FREELANCER_EDIT_ARTICLE_SUCCESS =
  "FREELANCER_EDIT_ARTICLE_SUCCESS";
export const FREELANCER_EDIT_ARTICLE_FAIL = "FREELANCER_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  post_id,
  category_ids,
  title,
  body,
  status,
  cover_img,
  author_name,
  published_at
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("post_id", post_id);
  params.append("category_ids", category_ids);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  if (cover_img) {
    params.append("cover_image", cover_img);
  }
  params.append("author_name", author_name);
  dispatch({
    type: FREELANCER_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/freelancer_post/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/other-articles"));
      } else {
        dispatch({
          type: FREELANCER_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const FREELANCER_EDIT_USERARTICLE_REQUEST =
  "FREELANCER_EDIT_USERARTICLE_REQUEST";
export const FREELANCER_EDIT_USERARTICLE_SUCCESS =
  "FREELANCER_EDIT_USERARTICLE_SUCCESS";
export const FREELANCER_EDIT_USERARTICLE_FAIL =
  "FREELANCER_EDIT_USERARTICLE_FAIL";
export const editUserArticle = ({
  post_id,
  category_ids,
  title,
  body,
  status,
  cover_img,
  author_name
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("post_id", post_id);
  params.append("category_ids", category_ids);
  params.append("title", title);
  params.append("body", body);
  params.append("status", status);
  if (cover_img) {
    params.append("cover_image", cover_img);
  }
  params.append("author_name", author_name);
  dispatch({
    type: FREELANCER_EDIT_USERARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/freelancer_post/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_EDIT_USERARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/user/management/articles"));
      } else {
        dispatch({
          type: FREELANCER_EDIT_USERARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};

export const FREELANCER_NEW_USERARTICLE_REQUEST =
  "FREELANCER_NEW_USERARTICLE_REQUEST";
export const FREELANCER_NEW_USERARTICLE_SUCCESS =
  "FREELANCER_NEW_USERARTICLE_SUCCESS";
export const FREELANCER_NEW_USERARTICLE_FAIL =
  "FREELANCER_NEW_USERARTICLE_FAIL";
export const newUserArticle = ({
  // post_id,
  category_ids
  // title,
  // body,
  // status,
  // cover_img,
  // author_name,
  // published_at
}) => dispatch => {
  // let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  // params.append("post_id", post_id);
  // params.append("category_ids", category_ids);
  // params.append("title", title);
  // params.append("body", body);
  // params.append("status", status);
  // if (cover_img) {
  //   params.append("cover_image", cover_img);
  // }
  // params.append("author_name", author_name);
  dispatch({
    type: FREELANCER_NEW_USERARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/freelancer_post/create",
      data: {
        category_ids
      },
      method: "POST"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: FREELANCER_NEW_USERARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        // dispatch(push("/user/management/articles"));
        dispatch(
          push("/dash/user/management/articles/" + data.data.id + "/edit")
        );
      } else {
        dispatch({
          type: FREELANCER_NEW_USERARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};
